import { render } from "./Alerts-page.vue?vue&type=template&id=8ec345ea"
import script from "./Alerts-page.vue?vue&type=script&lang=js"
export * from "./Alerts-page.vue?vue&type=script&lang=js"

import "./Alerts-page.vue?vue&type=style&index=0&id=8ec345ea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__